module.exports = __webpack_public_path__ + "static/media/nc.b72ab6b2.svg";